import { useState } from 'react';
import { Link } from 'react-router-dom';
import { login } from '../../api/Auth';
import ReCAPTCHA from 'react-google-recaptcha';

const { REACT_APP_ClientKey, REACT_APP_VERSION } = process.env;

function SignIn() {
  const clientKey = `${REACT_APP_ClientKey}`;
  //States
  console.log(process.env);
  const [alertMessage, setAlertMessage] = useState('');
  const [noError, setNoError] = useState(true);
  const [password, setPassword] = useState('');
  const [email, setEmail] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [captcha, setCaptcha] = useState(true);

  //Functions

  //Shows password
  const handleShowPassword = (event: any) => {
    event.preventDefault();
    setShowPassword(!showPassword);
  };

  //Handles the change in inputted password
  const handleInputChange = (event: any) => {
    event.preventDefault();
    const target = event.target;
    if (target.name === 'password') {
      setPassword(event.target.value);
    }
    if (target.name === 'email') {
      setEmail(event.target.value);
    }
  };

  //Handles the submit
  const handleSubmit = (event: any) => {
    event.preventDefault();
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
    let error = false;

    //Validations for the email
    if (regex.test(email)) {
      setNoError(false);
    } else {
      error = true;
      setNoError(true);

      return setAlertMessage('Enter valid email');
    }

    //Validations for the password
    if (password.length > 0) {
      setNoError(false);
      setAlertMessage('');
    } else {
      error = true;
      setNoError(true);
    }

    setAlertMessage('');
    if (!error) {
      const data = {
        email: email,
        password: password,
      };
      login(data);
    }
  };

  if (captcha) {
    return (
      <div>
        <div className='container'>
          <div className='row mt-5'>
            <div className='col-3'>
              <img src='/assets/Logos/AppIcon.png' />
            </div>
            <div className='col'></div>
          </div>
          <div className='row mt-5'>
            <div className='col-4'></div>
            <div className='col'>
              <h1>Sign In</h1>
              {alertMessage != '' && alertMessage != 'success' && (
                <div className='alert alert-danger' role='alert'>
                  {alertMessage}
                </div>
              )}
              <form>
                <div className='mb-3'>
                  <label className='form-label'>Email address</label>
                  <input
                    type='email'
                    className='form-control'
                    name='email'
                    value={email}
                    onChange={handleInputChange}
                  />
                </div>
                <label className='form-label'>Password</label>
                <div className='input-group mb-3'>
                  <input
                    type={showPassword ? 'text' : 'password'}
                    className='form-control'
                    name='password'
                    value={password}
                    onChange={handleInputChange}
                  />
                  <span
                    className='input-group-text'
                    onClick={handleShowPassword}
                  >
                    {showPassword ? (
                      <i className='bi bi-eye-slash-fill'></i>
                    ) : (
                      <i className='bi bi-eye-fill'></i>
                    )}
                  </span>
                </div>
                <div className='input-group mb-3'>
                  <Link to='/forgotPassword'>Forgot Password</Link>
                </div>

                <button
                  type='submit'
                  className='btn btn-primary'
                  onClick={handleSubmit}
                >
                  Submit
                </button>
              </form>
            </div>
            <div className='col-4'></div>
          </div>
        </div>
        <div style={{ position: 'fixed', bottom: '0', right: '1%' }}>
          <p>v{REACT_APP_VERSION}</p>
        </div>
      </div>
    );
  } else {
    return (
      <div style={{ position: 'absolute', left: '40%', top: '40%' }}>
        <div>
          <ReCAPTCHA
            sitekey={clientKey}
            onChange={() => {
              setCaptcha(true);
            }}
          />
        </div>
      </div>
    );
  }
}

export default SignIn;
